import React, { useState, useEffect } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const PersonalInfoForm = ({ data, onSave }) => {
  const [formData, setFormData] = useState({
    legal_first_name: data?.legal_first_name || '',
    legal_middle_name: data?.legal_middle_name || '',
    legal_last_name: data?.legal_last_name || '',
    preferred_name: data?.preferred_name || '',
    date_of_birth: data?.date_of_birth || '',
    email: data?.email || '',
    phone: data?.phone || '',
    address: data?.address || '',
    city: data?.city || '',
    state: data?.state || '',
    zip_code: data?.zip_code || '',
    country: data?.country || 'United States',
    citizenship: data?.citizenship || 'US Citizen'
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <Label htmlFor="legalFirstName">Legal First Name *</Label>
          <Input
            id="legal_first_name"
            name="legal_first_name"
            value={formData.legal_first_name}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <Label htmlFor="legal_middle_name">Middle Name</Label>
          <Input
            id="legal_middle_name"
            name="legal_middle_name"
            value={formData.legal_middle_name}
            onChange={handleChange}
          />
        </div>
        <div>
          <Label htmlFor="legal_last_name">Legal Last Name *</Label>
          <Input
            id="legal_last_name"
            name="legal_last_name"
            value={formData.legal_last_name}
            onChange={handleChange}
            required
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="preferred_name">Preferred Name</Label>
          <Input
            id="preferred_name"
            name="preferred_name"
            value={formData.preferred_name}
            onChange={handleChange}
            placeholder="If different from legal name"
          />
        </div>
        <div>
          <Label htmlFor="date_of_birth">Date of Birth *</Label>
          <Input
            id="date_of_birth"
            name="date_of_birth"
            type="date"
            value={formData.date_of_birth}
            onChange={handleChange}
            required
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="email">Email Address *</Label>
          <Input
            id="email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <Label htmlFor="phone">Phone Number *</Label>
          <Input
            id="phone"
            name="phone"
            type="tel"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>
      </div>

      <div>
        <Label htmlFor="address">Street Address *</Label>
        <Input
          id="address"
          name="address"
          value={formData.address}
          onChange={handleChange}
          required
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <Label htmlFor="city">City *</Label>
          <Input
            id="city"
            name="city"
            value={formData.city}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <Label htmlFor="state">State/Province *</Label>
          <Input
            id="state"
            name="state"
            value={formData.state}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <Label htmlFor="zip_code">ZIP/Postal Code *</Label>
          <Input
            id="zip_code"
            name="zip_code"
            value={formData.zip_code}
            onChange={handleChange}
            required
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="country">Country *</Label>
          <Select value={formData.country} onValueChange={(value) => handleSelectChange('country', value)}>
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="United States">United States</SelectItem>
              <SelectItem value="Canada">Canada</SelectItem>
              <SelectItem value="United Kingdom">United Kingdom</SelectItem>
              <SelectItem value="Other">Other</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label htmlFor="citizenship">Citizenship Status *</Label>
          <Select value={formData.citizenship} onValueChange={(value) => handleSelectChange('citizenship', value)}>
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="US Citizen">US Citizen</SelectItem>
              <SelectItem value="US Permanent Resident">US Permanent Resident</SelectItem>
              <SelectItem value="International">International Student</SelectItem>
              <SelectItem value="Other">Other</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      <div className="flex justify-end">
        <Button type="submit">Save & Continue</Button>
      </div>
    </form>
  );
};

export default PersonalInfoForm;